import "flag-icons/css/flag-icons.min.css";
import "v-phone-input/styles";
import { createVPhoneInput, VPhoneCountryFlagSvg, selectPhoneCountryInput } from "v-phone-input";

export function createPhoneInput(i18n) {
  // @ts-ignore
  return createVPhoneInput({
    ...selectPhoneCountryInput,
    countryDisplayComponent: VPhoneCountryFlagSvg,
    invalidMessage: (options) => i18n.global.t("errors.validator.phone_number", options),
    phoneProps: {
      variant: "outlined",
      density: "comfortable",
    },
    countryProps: {
      variant: "outlined",
      density: "comfortable",
    },
  });
}
